import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import { Button, DialogContent, IconButton } from "@material-ui/core";
import { RadioProps } from '@material-ui/core/Radio';

interface RetreatPopupProps extends RadioProps {
    popState: any[],
    transferId: string | null,
    retreatTransfer: any
};


const useStyles = makeStyles(() => ({
    typoLight: {
        fontSize: 24,
        fontWeight: 400,
        color: "#FFF",
    },
}));

const RetreatPopup: React.FC<RetreatPopupProps> = ({ 
    popState, 
    transferId, 
    retreatTransfer }) => {
    const classes = useStyles();

    return (
        <Dialog
            open={popState[0]}
            PaperProps={{
                style: {
                    backgroundColor: "#FFF",
                },
            }}
            onClose={() => popState[1](false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
        >
            <DialogContent
                style={{
                    width: 360,
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    overflow: "hidden",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Typography
                        className={classes.typoLight}
                        style={{ color: "#14191C" }}
                        gutterBottom
                    >
                        Retreat Transfer
                    </Typography>
                    <IconButton
                        style={{ padding: 0 }}
                        onClick={() => popState[1](false)}
                        aria-label="close"
                    >
                        <CloseIcon style={{ color: "#000" }} />
                    </IconButton>
                </div>
                <Typography className={classes.typoLight} style={{ color: "#333333" }} >Are you sure you would like to retreat this transfer?</Typography>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: 15,
                        marginTop: 15,
                    }}
                >
                    <Button
                        style={{
                            width: 163,
                            height: 44,
                            background: "#ECECEC",
                            color: "#03090E",
                            textTransform: "none",
                            fontWeight: 700,
                            fontSize: 19,
                        }}
                        variant="contained"
                        color="primary"
                        disableElevation
                        onClick={() => popState[1](false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        style={{
                            width: 163,
                            height: 44,
                            background: "#02489D",
                            textTransform: "none",
                            fontWeight: 700,
                            fontSize: 19,
                        }}
                        variant="contained"
                        color="primary"
                        disableElevation
                        onClick={() => retreatTransfer(transferId, popState)}
                    >
                        Yes
                    </Button>
                </div>
            </DialogContent>

        </Dialog>
    );
};

export default RetreatPopup;